export interface ErrorStateInterface {
  errorMessage: string;
  timestamp: number;
}

export const initErrorState: ErrorStateInterface = {
  errorMessage: null,
  timestamp: null,
};
